export {
  BlockNavigationMyPageIndex,
  type BlockNavigationMyPageIndexProps,
} from './BlockNavigationMyPageIndex';
